export const setPrincipals = principals => ({
  setState
}) => setState({
  principals
});
export const addPrincipals = newPrincipals => ({
  setState,
  getState
}) => setState({
  principals: [...newPrincipals, ...getState().principals]
});
export const removePrincipal = ari => ({
  setState,
  getState
}) => setState({
  principals: getState().principals.filter(p => !p.ari.equals(ari))
});